export const SIDENAV_GROUP_BY = Object.freeze({
  ALPHA: "alpha",
  BETA: "beta",
  GAMMA: "gamma",
  DELTA: "delta",
  EPSILON: "epsilon",
  NIU: "niu",
});

export default {};
